import React, { useEffect, useState } from "react";
import BottyAI from "src/assets/images/AI_process.png";
import { Modal, ModalBody, Progress } from "reactstrap";

const BottyPopup = ({ t, showBottyPopup }) => {
    const [isOpen, setIsOpen] = useState(showBottyPopup);

    const togglePopup = () => {
        setIsOpen(!isOpen);
    };

    useEffect(() => {
        setIsOpen(showBottyPopup);
    }, [ showBottyPopup ]);

    return (
        <Modal
            isOpen={isOpen}
            toggle={togglePopup}
            contentClassName="border-0 rounded-4 shadow-lg overflow-hidden"
        >
            <ModalBody className="position-relative text-center px-5 py-5">
                <div
                    className="position-absolute top-0 start-50 translate-middle-x"
                    style={{
                        width: 220,
                        height: 220,
                        background:
                            "rgba(13, 110, 253, 0.08)",
                        filter: "blur(60px)",
                        borderRadius: "50%",
                        zIndex: 0
                    }}
                />
                <div className="position-relative z-1">
                    <div className="mb-4">
                        <img
                            src={BottyAI}
                            alt={t('AI Assistant')}
                            width={150}
                            className="img-fluid"
                        />
                    </div>

                    <div className="mb-3">
                        <span
                            className="px-3 py-2 rounded-pill"
                            style={{
                                background:
                                    "rgba(13, 110, 253, 0.1)",
                                color: "#0d6efd",
                                fontSize: 13,
                                fontWeight: 600,
                                letterSpacing: 0.3
                            }}
                        >
                            {t('AI PROCESSING')}
                        </span>
                    </div>

                    <h3 className="fw-bold mb-3">
                        {t('Creating Other Asset')}
                    </h3>

                    <p
                        className="text-muted mx-auto mb-4"
                        style={{
                            maxWidth: 360,
                            lineHeight: 1.7
                        }}
                    >
                        {t('Our AI is analyzing the provided information and generating the other asset details automatically.')}
                    </p>

                    <Progress
                        animated
                        striped
                        value={100}
                        style={{
                            height: 10,
                            borderRadius: 999
                        }}
                        className="mb-3"
                    />

                    <small className="text-muted">
                        {t('This may take a few moments')}...
                    </small>
                </div>
            </ModalBody>
        </Modal>
    );
};

export default BottyPopup;
